import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 80;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    landscape: {
      baseWidth: width * 1.08,
      baseHeight: height,
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-70),
        y: convertToPercentageY(114 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(90),
        y: convertToPercentageY(186 + yOffset),
        duration: 170,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_2'));
          G.sfx.whoosh.play();
        },
      },
      {
        wait: 160,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_1'));
        },
      },
      {
        wait: 1270,
        callback: () => {
          G.sfx.xylophone_positive_12.play();
        },
      },
      {
        y: convertToPercentageY(21 + yOffset),
        duration: 100,
        callback: (object, config) => {
          const { parent } = config;
          parent.addChildAt(object, 0);
        },
      },
      {
        y: convertToPercentageY(95 + yOffset),
        duration: 60,
      },
      {
        y: convertToPercentageY(145 + yOffset),
        duration: 170,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(165),
        y: convertToPercentageY(277),
        alpha: 0,
        angle: -45,
        scale: 0.1,
      },
      {
        wait: 400,
      },
      {
        x: convertToPercentageX(208),
        y: convertToPercentageY(356),
        alpha: 1,
        angle: 76,
        scale: 0.24,
        duration: 67,
      },
      {
        x: convertToPercentageX(307),
        y: convertToPercentageY(539),
        angle: 45,
        scale: 0.58,
        duration: 166,
      },
      {
        angle: 90,
        scale: 1.68,
        duration: 166,
      },
      {
        scale: 1.8,
        duration: 67,
        callback: () => {
          G.sb('corruptWindow').dispatch();
        },
      },
      {
        scale: 1.68,
        duration: 34,
      },
      {
        y: convertToPercentageY(655),
        duration: 135,
      },
      {
        alpha: 0,
        y: convertToPercentageY(1070),
        duration: 466,
      },
    ],
  },
];
